var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('pm-nav-bar',{attrs:{"user":_vm.user,"menu-expanded":_vm.menuExpanded},on:{"sign-out-clicked":_vm.signOut,"menu-clicked":_vm.switchMenuState}}),_c('main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }